import { entityScripts } from "@/lib/entityJsonLd";
import { createFileRoute } from "@tanstack/react-router";
import CountryHub from "@/pages/CountryHub";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findCountry } from "@/lib/entities";

export const Route = createFileRoute("/countries/$slug")({
  head: ({ params }) => {
    const label = findCountry(params.slug)?.label ?? readable(params.slug);
    return {
      scripts: entityScripts({ type: "Country", name: label, path: `/countries/${params.slug}`, crumbs: [{ name: "Countries", path: "/countries" }, { name: label, path: `/countries/${params.slug}` }], extra: {} }),
      meta: socialMeta({
        seo: { topics: ["leagues", "footballPredictions"], entities: [readable(params.slug)] },
        title: `${label} Football Predictions & Betting Tips | Statlign`,
        description: `${label} football predictions, value odds and betting tips from our 50-strategy analysis engine, with the reasoning behind every call.`,
      }),
    };
  },
  component: () => (
    <MainLayout>
      <CountryHub />
    </MainLayout>
  ),
});
